<app-dashboard-layout [loading]="loading" [downloader]="downloader" [dialog]="dialog">
  <app-notification-alert [data]="apiService.notification"></app-notification-alert>
  <div class="pb-4 grid gap-4 grid-cols-2">
    <div class="">
      <input [disabled]="!skeletonLoader && shopItems.length == 0" (input)="filterItemLinks($event)" type="text" placeholder="Search Items"
      class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light" />
    </div>
    <div class="text-right">
      <app-button-primary type="button" [disabled]="loading" [routerLink]="'/purchases/order-details'">  
        <div class="material-icons">shopping_cart</div>
        <div>
          View Cart 
          <span *ngIf="cart.ItemCount! > 0" class="bg-danger rounded-full m-1 p-1">{{cart.ItemCount}}</span>
        </div>
      </app-button-primary>
    </div>
  </div>
  
  <app-no-content *ngIf="!skeletonLoader && links.length == 0" caption="No Items found!"> </app-no-content>
  <div *ngIf="skeletonLoader" class="pb-4 grid gap-4 grid-cols-1 sm:grid-cols-2 md:gap-6 lg:grid-cols-3 xl:grid-cols-4">
    <div *ngFor="let i of [1, 2, 3, 4, 6, 7, 8]" class="border rounded-md bg-gray-300 h-20 animate-pulse"></div>
  </div>
  <section
    class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:gap-6 lg:grid-cols-3 xl:grid-cols-4"
  >

    <app-dashboard-card
      *ngFor="let link of links"
      (click)="showItemPopup(link.title)"
      [title]="link.text"
      [icon]="link.icon"
      [caption]="link.text"
    ></app-dashboard-card>
  </section>
</app-dashboard-layout>

<app-shop-item-popup *ngIf="showShopItemPopup" [shopItem]="selectedShopItem" (closePopup)="closePopup($event)"></app-shop-item-popup>

